import {
  Token_ANY_getInstance9hqrmgh2e8rx as Token_ANY_getInstance,
  Token_BOOLEAN_getInstance145ap4wnd8afw as Token_BOOLEAN_getInstance,
  Token_STRING_getInstance2zgh44vqhr2y8 as Token_STRING_getInstance,
  Token_NUMBER_getInstance2xbg3l3gtc5w1 as Token_NUMBER_getInstance,
  Token_LONG_getInstance1q4dpv6tjhcl0 as Token_LONG_getInstance,
  Token_BEGIN_OBJECT_getInstanceif3n49bygvyp as Token_BEGIN_OBJECT_getInstance,
  Token_BEGIN_ARRAY_getInstanceq6fmixkefrta as Token_BEGIN_ARRAY_getInstance,
  Token_NULL_getInstance1u01li7150917 as Token_NULL_getInstance,
  Token_END_DOCUMENT_getInstance2vm30j439b0cy as Token_END_DOCUMENT_getInstance,
  Token_END_OBJECT_getInstance2x8wxmu47aqr2 as Token_END_OBJECT_getInstance,
  Token_END_ARRAY_getInstance3mpk3gmigb9kl as Token_END_ARRAY_getInstance,
  Token_NAME_getInstance1jn9wytcokkr3 as Token_NAME_getInstance,
  JsonReaderhn8ohc8v7l9p as JsonReader,
} from './JsonReader.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { readAny17j2jqaxubdko as readAny } from './JsonReaders.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { JsonDataException2rdtm884tky1l as JsonDataException } from '../../exception/Exceptions.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toDouble1kn912gjoizjp as toDouble,
  toInt2q8uldh7sc951 as toInt,
  toLongkk4waq8msp1k as toLong,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  toDoubleExact18clzpruqqw2d as toDoubleExact,
  toIntExact1n46an7ryabg9 as toIntExact,
  toIntExact1p16u7ro59o31 as toIntExact_0,
  toLongExact9cht6g9si07j as toLongExact,
} from './internal/Utils.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function anyToToken($this, any) {
  var tmp;
  if (any == null) {
    tmp = Token_NULL_getInstance();
  } else {
    if (isInterface(any, KtList())) {
      tmp = Token_BEGIN_ARRAY_getInstance();
    } else {
      if (isInterface(any, KtMap())) {
        tmp = Token_BEGIN_OBJECT_getInstance();
      } else {
        if (typeof any === 'number') {
          tmp = Token_NUMBER_getInstance();
        } else {
          if (typeof any === 'bigint') {
            tmp = Token_LONG_getInstance();
          } else {
            if (typeof any === 'number') {
              tmp = Token_NUMBER_getInstance();
            } else {
              if (any instanceof JsonNumber()) {
                tmp = Token_NUMBER_getInstance();
              } else {
                if (typeof any === 'string') {
                  tmp = Token_STRING_getInstance();
                } else {
                  if (typeof any === 'boolean') {
                    tmp = Token_BOOLEAN_getInstance();
                  } else {
                    tmp = Token_ANY_getInstance();
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function advanceIterator($this) {
  if ($this.a4d_1 === 0) {
    $this.u4c_1 = Token_END_DOCUMENT_getInstance();
    return Unit_instance;
  }
  var currentIterator = ensureNotNull($this.y4c_1[$this.a4d_1 - 1 | 0]);
  var tmp = $this.w4c_1[$this.a4d_1 - 1 | 0];
  if (!(tmp == null) ? typeof tmp === 'number' : false) {
    var tmp_0 = $this.w4c_1;
    var tmp_1 = $this.a4d_1 - 1 | 0;
    var tmp_2 = $this.w4c_1[$this.a4d_1 - 1 | 0];
    tmp_0[tmp_1] = ((!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE()) + 1 | 0;
  }
  if (currentIterator.q1()) {
    var next = currentIterator.r1();
    $this.v4c_1 = next;
    var tmp_3 = $this;
    var tmp_4;
    if (!(next == null) ? isInterface(next, Entry()) : false) {
      tmp_4 = Token_NAME_getInstance();
    } else {
      tmp_4 = anyToToken($this, next);
    }
    tmp_3.u4c_1 = tmp_4;
  } else {
    var tmp_5 = $this;
    var tmp_6;
    var tmp_7 = $this.w4c_1[$this.a4d_1 - 1 | 0];
    if (!(tmp_7 == null) ? typeof tmp_7 === 'number' : false) {
      tmp_6 = Token_END_ARRAY_getInstance();
    } else {
      tmp_6 = Token_END_OBJECT_getInstance();
    }
    tmp_5.u4c_1 = tmp_6;
  }
}
function increaseStack($this) {
  if ($this.a4d_1 === $this.w4c_1.length) {
    $this.w4c_1 = copyOf($this.w4c_1, imul($this.w4c_1.length, 2));
    $this.x4c_1 = copyOf($this.x4c_1, imul($this.x4c_1.length, 2));
    $this.z4c_1 = copyOf_0($this.z4c_1, imul($this.z4c_1.length, 2));
    $this.y4c_1 = copyOf($this.y4c_1, imul($this.y4c_1.length, 2));
  }
  $this.a4d_1 = $this.a4d_1 + 1 | 0;
}
function findName($this, needle, haystack) {
  var expectedIndex = $this.z4c_1[$this.a4d_1 - 1 | 0];
  if (expectedIndex < haystack.q2() && haystack.r2(expectedIndex) === needle) {
    $this.z4c_1[$this.a4d_1 - 1 | 0] = $this.z4c_1[$this.a4d_1 - 1 | 0] + 1 | 0;
    return expectedIndex;
  } else {
    var index = haystack.r4(needle);
    if (!(index === -1)) {
      $this.z4c_1[$this.a4d_1 - 1 | 0] = index + 1 | 0;
    }
    return index;
  }
}
function getPathAsString($this) {
  return joinToString($this.k2s(), '.');
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      e3y(_this__u8e3s4) {
        if (_this__u8e3s4 instanceof MapJsonReader())
          return _this__u8e3s4;
        var token = _this__u8e3s4.w3x();
        // Inline function 'kotlin.check' call
        if (!token.equals(Token_BEGIN_OBJECT_getInstance())) {
          var message = 'Failed to buffer json reader, expected `BEGIN_OBJECT` but found `' + token.toString() + '` json token';
          throw IllegalStateException().o(toString(message));
        }
        var pathRoot = _this__u8e3s4.k2s();
        var tmp = readAny(_this__u8e3s4);
        var data = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
        // Inline function 'kotlin.apply' call
        var this_0 = new (MapJsonReader())(data, pathRoot);
        this_0.q4c(this_0.s49());
        return this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var MapJsonReaderClass;
function MapJsonReader() {
  if (MapJsonReaderClass === VOID) {
    class $ {
      constructor(root, pathRoot) {
        pathRoot = pathRoot === VOID ? emptyList() : pathRoot;
        this.s4c_1 = root;
        this.t4c_1 = pathRoot;
        this.v4c_1 = null;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.w4c_1 = Array(64);
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_0.x4c_1 = Array(64);
        var tmp_1 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_1.y4c_1 = Array(64);
        this.z4c_1 = new Int32Array(64);
        this.a4d_1 = 0;
        this.b4d_1 = true;
        this.u4c_1 = anyToToken(this, this.s4c_1);
        this.v4c_1 = this.s4c_1;
      }
      n3y() {
        // Inline function 'kotlin.apply' call
        if (!this.w3x().equals(Token_BEGIN_ARRAY_getInstance())) {
          throw JsonDataException().x46('Expected BEGIN_ARRAY but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.v4c_1;
        var currentValue = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : THROW_CCE();
        increaseStack(this);
        this.w4c_1[this.a4d_1 - 1 | 0] = -1;
        this.y4c_1[this.a4d_1 - 1 | 0] = currentValue.p1();
        advanceIterator(this);
        return this;
      }
      o3y() {
        // Inline function 'kotlin.apply' call
        if (!this.w3x().equals(Token_END_ARRAY_getInstance())) {
          throw JsonDataException().x46('Expected END_ARRAY but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        this.a4d_1 = this.a4d_1 - 1 | 0;
        this.y4c_1[this.a4d_1] = null;
        this.w4c_1[this.a4d_1] = null;
        advanceIterator(this);
        return this;
      }
      f3y() {
        // Inline function 'kotlin.apply' call
        if (!this.w3x().equals(Token_BEGIN_OBJECT_getInstance())) {
          throw JsonDataException().x46('Expected BEGIN_OBJECT but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        increaseStack(this);
        var tmp = this.x4c_1;
        var tmp_0 = this.a4d_1 - 1 | 0;
        var tmp_1 = this.v4c_1;
        tmp[tmp_0] = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
        this.r4c();
        return this;
      }
      g3y() {
        // Inline function 'kotlin.apply' call
        this.a4d_1 = this.a4d_1 - 1 | 0;
        this.y4c_1[this.a4d_1] = null;
        this.w4c_1[this.a4d_1] = null;
        this.x4c_1[this.a4d_1] = null;
        advanceIterator(this);
        return this;
      }
      q1() {
        switch (this.w3x().w1_1) {
          case 3:
            return false;
          case 1:
            return false;
          default:
            return true;
        }
      }
      w3x() {
        return this.u4c_1;
      }
      h3y() {
        if (!this.w3x().equals(Token_NAME_getInstance())) {
          throw JsonDataException().x46('Expected NAME but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.v4c_1;
        var data = (!(tmp == null) ? isInterface(tmp, Entry()) : false) ? tmp : THROW_CCE();
        this.w4c_1[this.a4d_1 - 1 | 0] = data.m3();
        this.v4c_1 = data.n3();
        this.u4c_1 = anyToToken(this, data.n3());
        return data.m3();
      }
      s3y() {
        var value = this.v4c_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value.toString();
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value.toString();
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value.toString();
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = value;
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = value.q4a_1;
                } else {
                  throw JsonDataException().x46('Expected a String but got ' + toString_0(value) + ' instead');
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      io() {
        if (!this.w3x().equals(Token_BOOLEAN_getInstance())) {
          throw JsonDataException().x46('Expected BOOLEAN but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        var tmp = this.v4c_1;
        // Inline function 'kotlin.also' call
        var this_0 = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
        advanceIterator(this);
        return this_0;
      }
      r49() {
        if (!this.w3x().equals(Token_NULL_getInstance())) {
          throw JsonDataException().x46('Expected NULL but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        advanceIterator(this);
        return null;
      }
      x3y() {
        switch (this.w3x().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().x46('Expected a Double but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.v4c_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toDoubleExact(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = value;
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toDouble(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toDouble(value.q4a_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected a Double but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      ok() {
        switch (this.w3x().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().x46('Expected an Int but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.v4c_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = value;
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = toIntExact_0(value);
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toIntExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toInt(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toInt(value.q4a_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected an Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      fo() {
        switch (this.w3x().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().x46('Expected a Long but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.v4c_1;
        var tmp;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp = fromInt(value);
        } else {
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp = value;
          } else {
            if (!(value == null) ? typeof value === 'number' : false) {
              tmp = toLongExact(value);
            } else {
              if (!(value == null) ? typeof value === 'string' : false) {
                tmp = toLong(value);
              } else {
                if (value instanceof JsonNumber()) {
                  tmp = toLong(value.q4a_1);
                } else {
                  // Inline function 'kotlin.error' call
                  var message = 'Expected Int but got ' + toString_0(value) + ' instead';
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      o4c() {
        switch (this.w3x().w1_1) {
          case 5:
          case 6:
          case 7:
            break;
          default:
            throw JsonDataException().x46('Expected a Number but was ' + this.w3x().toString() + ' at path ' + getPathAsString(this));
        }
        var value = this.v4c_1;
        var tmp;
        var tmp_0;
        if (!(value == null) ? typeof value === 'number' : false) {
          tmp_0 = true;
        } else {
          var tmp_1;
          if (!(value == null) ? typeof value === 'bigint' : false) {
            tmp_1 = true;
          } else {
            tmp_1 = !(value == null) ? typeof value === 'number' : false;
          }
          tmp_0 = tmp_1;
        }
        if (tmp_0) {
          tmp = new (JsonNumber())(toString(value));
        } else {
          if (!(value == null) ? typeof value === 'string' : false) {
            tmp = new (JsonNumber())(value);
          } else {
            if (value instanceof JsonNumber()) {
              tmp = value;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Expected JsonNumber but got ' + toString_0(value) + ' instead';
              throw IllegalStateException().o(toString(message));
            }
          }
        }
        // Inline function 'kotlin.also' call
        var this_0 = tmp;
        advanceIterator(this);
        return this_0;
      }
      v3x() {
        advanceIterator(this);
      }
      l6() {
      }
      p4c(names) {
        while (this.q1()) {
          var name = this.h3y();
          var index = findName(this, name, names);
          if (!(index === -1)) {
            return index;
          }
          if (!this.b4d_1) {
            throw JsonDataException().x46("Unknown key '" + name + "' found at path: '" + getPathAsString(this) + "'");
          }
          this.v3x();
        }
        return -1;
      }
      r4c() {
        var container = this.x4c_1[this.a4d_1 - 1 | 0];
        this.w4c_1[this.a4d_1 - 1 | 0] = null;
        var tmp = this.y4c_1;
        var tmp_0 = this.a4d_1 - 1 | 0;
        // Inline function 'kotlin.collections.iterator' call
        tmp[tmp_0] = ensureNotNull(container).l3().p1();
        this.z4c_1[this.a4d_1 - 1 | 0] = 0;
        advanceIterator(this);
      }
      k2s() {
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList().p2();
        result.u2(this.t4c_1);
        var inductionVariable = 0;
        var last = this.a4d_1;
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_safe_receiver = this.w4c_1[index];
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              result.i2(tmp0_safe_receiver);
            }
          }
           while (inductionVariable < last);
        return result;
      }
      s49() {
        return this.b4d_1;
      }
      q4c(ignoreUnknownKeys) {
        this.b4d_1 = ignoreUnknownKeys;
      }
    }
    initMetadataForClass($, 'MapJsonReader', VOID, VOID, [JsonReader()]);
    MapJsonReaderClass = $;
  }
  return MapJsonReaderClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  MapJsonReader as MapJsonReader2b7ri7r44421y,
  Companion_instance as Companion_instance6tw5jj3chxse,
};
//endregion

//# sourceMappingURL=MapJsonReader.mjs.map
